export const teeshirtSizes = [
    { age: '1 TO 2 AGE', number: '20', measure: '12.5 X 19 in' },
    { age: '3 AGE', number: '22', measure: '13.5 X 20 in' },
    { age: '4 AGE', number: '24', measure: '14.5 X 21 in' },
    { age: '5 TO 6 AGE', number: '26', measure: '15.5 X 22 in' },
    { age: '7 TO 8 AGE', number: '28', measure: '16 X 23 in' },
    { age: '9 TO 10 AGE', number: '30', measure: '18 X 24 in' },
    { age: '11 TO 12 AGE', number: '32', measure: '18 X 26 in' },
    { age: 'XS', number: '34', measure: '19 X 27 in' },
    { age: 'S', number: '36', measure: '20 X 28 in' },
    { age: 'M', number: '38', measure: '21 X 29 in' },
    { age: 'L', number: '40', measure: '22 X 30 in' },
    { age: 'XL', number: '42', measure: '23 X 31 in' },
    { age: '2XL', number: '44', measure: '24 X 32 in' },
    { age: '3XL', number: '46', measure: '25 X 33 in' },
    { age: '4XL', number: '48', measure: '26 X 34 in' },
    { age: '5XL', number: '50', measure: '27 X 35 in' },
    { age: '6XL', number: '52', measure: '28 X 35 in' },
];

export const halfSleeveSizes = [
    { age: '1 TO 2 AGE', number: '20', measure: '12.5 X 7 in' },
    { age: '3 AGE', number: '22', measure: '13 X 7.5 in' },
    { age: '4 AGE', number: '24', measure: '13.5 X 7.5 in' },
    { age: '5 TO 6 AGE', number: '26', measure: '14 X 8 in' },
    { age: '7 TO 8 AGE', number: '28', measure: '14.5 X 8.25 in' },
    { age: '9 TO 10 AGE', number: '30', measure: '15 X 8.5 in' },
    { age: '11 TO 12 AGE', number: '32', measure: '15.5 X 8.75 in' },
    { age: 'XS', number: '34', measure: '16.5 X 9.5 in' },
    { age: 'S', number: '36', measure: '17 X 10.25 in' },
    { age: 'M', number: '38', measure: '17.5 X 10.25 in' },
    { age: 'L', number: '40', measure: '19 X 10.25 in' },
    { age: 'XL', number: '42', measure: '20 X 11.5 in' },
    { age: '2XL', number: '44', measure: '20.5 X 12 in' },
    { age: '3XL', number: '46', measure: '21 X 12.5 in' },
    { age: '4XL', number: '48', measure: '21.5 X 13 in' },
    { age: '5XL', number: '50', measure: '22 X 13.5 in' },
    { age: '6XL', number: '52', measure: '22.5 X 14 in' },
];
export const fullSleeveSizes = [
    { age: '1 TO 2 YR', number: '20', measure: '12.5 X 20 in' },
    { age: '3 YR', number: '22', measure: '13 X 21 in' },
    { age: '4 YR -', number: '24', measure: '13.5 X 22 in' },
    { age: '5 TO 6 YR', number: '26', measure: '14 X 22 in' },
    { age: '7 TO 8 YR', number: '28', measure: '15 X 23 in' },
    { age: '9 TO 10 YR', number: '30', measure: '15.5 X 23.5 in' },
    { age: '11 TO 12 YR', number: '32', measure: '16 X 24 in' },
    { age: 'XS', number: '34', measure: '16.5 X 24.5 in' },
    { age: 'S', number: '36', measure: '17 X 25 in' },
    { age: 'M', number: '38', measure: '17.5 X 25 in' },
    { age: 'L', number: '40', measure: '19 X 26 in' },
    { age: 'XL', number: '42', measure: '20 X 26 in' },
    { age: '2XL', number: '44', measure: '20.5 X 26.5 in' },
    { age: '3XL', number: '46', measure: '21 X 26.5 in' },
    { age: '4XL', number: '48', measure: '21.5 X 27 in' },
    { age: '5XL', number: '50', measure: '22 X 27.5 in' },
    { age: '6XL', number: '52', measure: '22.5 X 27.5 in' },
];

export const defaultSize = [
  {
    id: '',
    label: '20',
    age: '1 TO 2 AGE',
    width: 12.5,
    height: 19,
    halfSleeveWidth: 12.5,
    halfSleeveHeight: 7,
    fullSleeveWidth: 12.5,
    fullSleeveHeight: 20
  },
  {
    id: '',
    label: '22',
    age: '3 AGE',
    width: 13.5,
    height: 20,
    halfSleeveWidth: 13,
    halfSleeveHeight: 7.5,
    fullSleeveWidth: 13,
    fullSleeveHeight: 21
  },
  {
    id: '',
    label: '24',
    age: '4 AGE',
    width: 14.5,
    height: 21,
    halfSleeveWidth: 13.5,
    halfSleeveHeight: 7.5,
    fullSleeveWidth: 13.5,
    fullSleeveHeight: 22
  },
  {
    id: '',
    label: '26',
    age: '5 TO 6 AGE',
    width: 15.5,
    height: 22,
    halfSleeveWidth: 14,
    halfSleeveHeight: 8,
    fullSleeveWidth: 14,
    fullSleeveHeight: 22
  },
  {
    id: '',
    label: '28',
    age: '7 TO 8 AGE',
    width: 16,
    height: 23,
    halfSleeveWidth: 14.5,
    halfSleeveHeight: 8.25,
    fullSleeveWidth: 15,
    fullSleeveHeight: 23
  },
  {
    id: '',
    label: '30',
    age: '9 TO 10 AGE',
    width: 18,
    height: 24,
    halfSleeveWidth: 15,
    halfSleeveHeight: 8.5,
    fullSleeveWidth: 15.5,
    fullSleeveHeight: 23.5
  },
  {
    id: '',
    label: '32',
    age: '11 TO 12 AGE',
    width: 18,
    height: 26,
    halfSleeveWidth: 15.5,
    halfSleeveHeight: 8.75,
    fullSleeveWidth: 16,
    fullSleeveHeight: 24
  },
  {
    id: '',
    label: '34',
    age: 'XS',
    width: 19,
    height: 27,
    halfSleeveWidth: 16.5,
    halfSleeveHeight: 9.5,
    fullSleeveWidth: 16.5,
    fullSleeveHeight: 24.5
  },
  {
    id: '',
    label: '36',
    age: 'S',
    width: 20,
    height: 28,
    halfSleeveWidth: 17,
    halfSleeveHeight: 10.25,
    fullSleeveWidth: 17,
    fullSleeveHeight: 25
  },
  {
    id: '',
    label: '38',
    age: 'M',
    width: 21,
    height: 29,
    halfSleeveWidth: 17.5,
    halfSleeveHeight: 10.5,
    fullSleeveWidth: 17.5,
    fullSleeveHeight: 25
  },
  {
    id: '',
    label: '40',
    age: 'L',
    width: 22,
    height: 30,
    halfSleeveWidth: 19,
    halfSleeveHeight: 10.75,
    fullSleeveWidth: 19,
    fullSleeveHeight: 26
  },
  {
    id: '',
    label: '42',
    age: 'XL',
    width: 23,
    height: 31,
    halfSleeveWidth: 20,
    halfSleeveHeight: 11.5,
    fullSleeveWidth: 20,
    fullSleeveHeight: 26
  },
  {
    id: '',
    label: '44',
    age: '2XL',
    width: 24,
    height: 32,
    halfSleeveWidth: 20.5,
    halfSleeveHeight: 12,
    fullSleeveWidth: 20.5,
    fullSleeveHeight: 26.5
  },
  {
    id: '',
    label: '46',
    age: '3XL',
    width: 25,
    height: 33,
    halfSleeveWidth: 21,
    halfSleeveHeight: 12.5,
    fullSleeveWidth: 21,
    fullSleeveHeight: 26.5
  },
  {
    id: '',
    label: '48',
    age: '4XL',
    width: 26,
    height: 34,
    halfSleeveWidth: 21.5,
    halfSleeveHeight: 13,
    fullSleeveWidth: 21.5,
    fullSleeveHeight: 27
  },
  {
    id: '',
    label: '50',
    age: '5XL',
    width: 27,
    height: 35,
    halfSleeveWidth: 22,
    halfSleeveHeight: 13.5,
    fullSleeveWidth: 22,
    fullSleeveHeight: 27.5
  },
  {
    id: '',
    label: '52',
    age: '6XL',
    width: 28,
    height: 35,
    halfSleeveWidth: 22.5,
    halfSleeveHeight: 14,
    fullSleeveWidth: 22.5,
    fullSleeveHeight: 27.5
  }
];
